<template lang="pug">
  v-card(v-if="consumption")
    v-card-title.primary--text.justify-center.grey.lighten-4
      .title HISTORIQUE {{ currentYear }}
    v-card-text
      v-layout.row
        v-flex
          v-layout.title.column.font-weight-bold
            v-flex.py-3.white--text Période
            v-divider
            v-flex.py-3 Consommation mensuelle
            v-divider
            v-flex.py-3  Total annuel
        v-flex
          v-layout.column
          v-flex.py-2
            v-btn.ma-0(
              flat icon color="grey"
              @click="prevMonth"
              :disabled="monthOffset === (consumption.length - 13)"
            )
              v-icon keyboard_arrow_left
          v-flex
          v-divider
          v-flex.py-3.title.white--text |
          v-divider
        v-flex(v-for="count, idx in displayConsumptions" :key="idx")
          v-layout.column
            v-flex.py-3.title.grey--text {{ headers[count.month-1] }} {{ count.year }}
            v-divider
            v-flex.py-3.title {{ count.quantity | spaceOut }}
            v-divider
            v-flex.py-3.title
              span(
                v-if="count.month === yearlyConsumption[count.year].first"
                :data-test="count.year + 'Total'"
              ) {{ yearlyConsumption[count.year].count | spaceOut }}
        v-flex
          v-layout.column
          v-flex.py-2
            v-btn.ma-0(flat icon color="grey" @click="nextMonth" :disabled="!monthOffset")
              v-icon keyboard_arrow_right
          v-flex
          v-divider
          v-flex.py-3.title.white--text |
          v-divider
</template>

<script>
export default {
  data() {
    return {
      headers: [
        'Jan',
        'Fev',
        'Mar',
        'Avr',
        'Mai',
        'Juin',
        'Juil',
        'Aou',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      monthOffset: 0,
    };
  },
  methods: {
    prevMonth() {
      if (this.monthOffset < (this.consumption.length - 13)) {
        // eslint-disable-next-line no-plusplus
        this.monthOffset++;
      }
    },
    nextMonth() {
      if (this.monthOffset) {
        // eslint-disable-next-line no-plusplus
        this.monthOffset--;
      }
    },
  },
  computed: {
    currentYear() {
      return this.$store.state.consumption.currentYear;
    },
    consumption() {
      if (this.$store.state.consumption.consumption.this_year_reports) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return this.$store.state.consumption.consumption.this_year_reports
          .sort((a, b) => parseInt(a.year, 10) - parseInt(b.year, 10));
      }
      return [];
    },
    yearlyConsumption() {
      return this.consumption.reduce((acc, it) => {
        if (!acc[it.year]) {
          acc[it.year] = { count: 0, first: it.month };
        }
        acc[it.year].count += it.quantity;
        acc[it.year].first = it.month;
        return acc;
      }, {});
    },
    displayConsumptions() {
      const idx = this.consumption.length - this.monthOffset;
      return this.consumption.slice(Math.max(idx - 13, 0), Math.max(idx, 13));
    },
  },
};
</script>
